import { useEffect, useRef, RefObject } from 'react';

export function useOutsideFocus(
  isOpen: boolean,
  onClose: () => void,
  menuRef: RefObject<HTMLElement>,
  triggerRef?: RefObject<HTMLElement> 
) {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;

    const handleClick = (event: MouseEvent) => {
      const menuEl = menuRef.current;
      const triggerEl = triggerRef?.current;
      const target = event.target as Node;

      if (!menuEl) return;

      if (menuEl.contains(target)) return;

      if (triggerEl && triggerEl.contains(target)) return;

      onCloseRef.current();
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCloseRef.current();
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        onCloseRef.current();
      }
    };

    window.addEventListener('click', handleClick);
    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('click', handleClick);
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isOpen, menuRef, triggerRef]);
}